import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment, isODM} from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SystemlogService {

  event: number;
  status: number;
  startDate: number;
  endDate: number;
  constructor(private http: HttpClient) { }

  ReadSystemLog(params): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/account/log/read`, params);
  }

  ReadSystemLogType(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/account/log/type/read`, {otp: params});
  }
}
